var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('h1',[_vm._v("为科技创新之飞跃而读书，为社会进步之繁荣而读书！")]),_c('div',{staticClass:"file"},[_c('span',{staticClass:"url",on:{"click":function($event){return _vm.download('apk')}}},[_vm._v("App下载(安卓)")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }